export type SlopeFlag =
  | 'ok'
  | 'acceptable-1-11'
  | 'acceptable-1-10'
  | 'limit-1-9'
  | 'max-absolute'
  | 'error';

export interface SlopeInfo {
  ratio: number;
  percent: number;
  flag: SlopeFlag;
}

export function classifyRatio(ratio: number): SlopeFlag {
  if (ratio >= 12) return 'ok';
  if (ratio >= 11) return 'acceptable-1-11';
  if (ratio >= 10) return 'acceptable-1-10';
  if (ratio >= 9) return 'limit-1-9';
  if (ratio >= 8) return 'max-absolute';
  return 'error';
}

export function computeSlope(heightIn: number, runIn: number): SlopeInfo {
  if (heightIn <= 0 || runIn <= 0) return { ratio: 0, percent: 0, flag: 'error' };
  const ratio = runIn / heightIn;
  const percent = (heightIn / runIn) * 100;
  return { ratio, percent, flag: classifyRatio(ratio) };
}
